import React from "react";
import Label from "./Label";

const CourseName = (props) => {
  const key = "cname-key";
  const display = (
    <div
      className="col-9 justify-content-left md-font card inner-buffer"
      onClick={(e) => props.focus(key, e)}
    >
      {props.courseName}
    </div>
  );
  const input = (
    <textarea
      id={key + "input"}
      className="col-9"
      maxLength={255}
      style={{ fontSize: "2rem" }}
      value={props.courseName}
      onChange={(e) => props.handleChange({ type: "course_name" }, e)}
      onClick={(e) => props.focus(key, e)}
    />
  );
  return (
    <div id={key} className="d-flex flex-row justify-content-left top-buffer">
      <Label boxed={true} text="Course Name:" />
      {props.focusKey == key ? input : display}
    </div>
  );
};

export default CourseName;
